export default __webpack_public_path__ + "img/fail.1e29de7.svg";